import { fa } from "timeago.js/lib/lang";
import { VideoSection } from "../../models/page-builder/video-section.model";

export const MOCK_VIDEO_SECTION: VideoSection = {
  type: "videos",
  content: {
    items: [
      {
        media: {
          type: "video",
          originalFileName: "background-original-1.mp4",
          uploadFileName: "background-1.mp4",
          url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
          videoSettings: {
            autoPlay: false,
          },
        },
        altText: "Join over 4,000+ users already growing with OnlineCourseHost.com",
        altTextColor: "#475467",
        description: "Lorem ipsum dolor sit amet consectetur. Faucibus faucibus commodo gravida aliquet. Eu nisi ac egestas lectus mattis urna nisi bibendum. Suspendisse consequat cursus consectetur odio libero sit ac morbi mauris. Magna fermentum feugiat pellentesque placerat nunc neque lectus. Odio a neque odio pellentesque vel euismod commodo nisl. Nibh hac nunc in amet maecenas. Pellentesque tristique sed adipiscing urna morbi egestas sit hendrerit fermentum. Natoque lobortis porttitor faucibus in viverra dolor imperdiet viverra.",
        descriptionColor: "#475467",
        buttonOrLink: {
          type: "link",
          linkName: "Learn how to add video to your website",
          linkUrl: "https://google.com/",
          linkColor: "#376CFB",
        },
      },
      {
        media: {
          type: "video",
          originalFileName: "background-original-2.mp4",
          uploadFileName: "background-2.mp4",
          url: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
          videoSettings: {
            autoPlay: false,
          },
        },
        altText: "Join over 4,000+ users already growing with OnlineCourseHost.com",
        altTextColor: "#475467",
        description: "Lorem ipsum dolor sit amet consectetur. Faucibus faucibus commodo gravida aliquet. Eu nisi ac egestas lectus mattis urna nisi bibendum. Suspendisse consequat cursus consectetur odio libero sit ac morbi mauris. Magna fermentum feugiat pellentesque placerat nunc neque lectus. Odio a neque odio pellentesque vel euismod commodo nisl. Nibh hac nunc in amet maecenas. Pellentesque tristique sed adipiscing urna morbi egestas sit hendrerit fermentum. Natoque lobortis porttitor faucibus in viverra dolor imperdiet viverra.",
        descriptionColor: "#475467",
        buttonOrLink: {
          type: "button",
          linkName: "Learn More",
          linkUrl: "https://google.com/",
          linkColor: "#FFFFFF",
          btnBgColor: "#7F56D9",
          btnBorderColor: "#7F56D9",
        }
      },
    ],
  },
  design: {
    layout: "card",
    contentAlignment: "leftRight",
    appearance: {
      cardBackgroundColor: "#808080",
      backgroundColor: "#ffffff",
    },
  },
};
